import headerMenu from "./src/header-menu";
import search from "./src/search";
import initScrollTopEvents from "./src/scroll-top";
import openAccordionTabs from "./src/baseAccordion"
import fpNews from "./src/fp-news";

window.addEventListener('DOMContentLoaded', function () {
	// Header menu
	headerMenu.init();

	search.init();


	if( this.document.querySelectorAll('body.home').length > 0 ) {
		fpNews.init();
	}

	// Scroll to top events
	initScrollTopEvents();

	openAccordionTabs();
});